interface Props {
  value: number
}

const TypeLocal = ({ value }: Props): JSX.Element | null => {
  switch (value) {
    case 1: {
      return <>Maison</>
    }
    case 2: {
      return <>Appartement</>
    }
    case 3: {
      return <>dependance</>
    }
    case 4: {
      return <>Local industrie commerce assimilé</>
    }
    default: {
      throw new Error(`value ${value} doesn't match with TypeLocal`)
    }
  }
}

export default TypeLocal
